import { CORE_DATA_BASE_URL } from '../config';
import * as Types from './types';
import { getHeaders } from '../fetch';

export async function execute(path, body, method = 'POST', isVoid = false, allowNotOkay = false) {
  const options = {
    method,
    headers: {
      ...getHeaders(),
      'Accept': 'application/json'
    }
  };
  if (['GET', 'HEAD'].indexOf(method) === -1) {
    options.body = JSON.stringify(body);
    options.headers['Content-Type'] = 'application/json';
  }
  const response = await fetch(
    CORE_DATA_BASE_URL + path,
    options
  );
  if (!allowNotOkay && !response.ok) {
    throw new Error('Response did not contain a 200-299 response code');
  }
  if (isVoid) {
    return null;
  }
  return response.json();
}

/** UserDataController Start **/

export async function createUser(user, password, userUuid = 'e6f3d782-7400-4015-a8db-aea734e60376') {
  return execute(`/user/${userUuid}/create-user`, {
    user: {
      '@class': Types.User,
      ...user
    },
    password
  }, 'POST', true);
}

export async function updateUser(user, userUuid = 'e6f3d782-7400-4015-a8db-aea734e60376') {
  return execute(`/user/${userUuid}/update-user`, {
    '@class': Types.User,
    ...user
  }, 'POST', true);
}

export async function changeUserPassword(object, userUuid = 'e6f3d782-7400-4015-a8db-aea734e60376') {
  return execute(`/user/${userUuid}/change-user-password`, object, 'POST', true);
}

/** UserDataController End **/

/** CustomerDataController Start **/

export async function saveCustomer(customer, userUuid = 'e6f3d782-7400-4015-a8db-aea734e60376') {
  return execute(`/customer/${userUuid}/save-customer`, {
    '@class': Types.Customer,
    ...customer
  }, 'POST', true);
}

/** CustomerDataController End **/

/** LocationDataController Start **/

export async function saveLocation(location, userUuid = 'e6f3d782-7400-4015-a8db-aea734e60376') {
  return execute(`/location/${userUuid}/save-location`, {
    '@class': Types.Location,
    ...location
  }, 'POST', true);
}

/** LocationDataController End **/

/** PendingProductInstanceDataController Start **/

export async function fetchAllPendingProductInstance() {
  return execute(`/pending-product-instance/fetch-all`, null, 'GET');
}

export async function setDeclinedForPendingProductInstance(id, declined) {
  return execute(`/pending-product-instance/${id}/set-declined`, declined, 'PUT', true);
}

/** PendingProductInstanceDataController End **/

/** ProductInstanceDataController Start **/

export async function saveProductInstance(productInstance, pendingProductInstanceIdentifier = null, userUuid = 'e6f3d782-7400-4015-a8db-aea734e60376') {
  return execute(`/product-instance/${userUuid}/save-product-instance${pendingProductInstanceIdentifier ? `?fromPendingProductInstance=${encodeURIComponent(pendingProductInstanceIdentifier)}` : ''}`, {
    '@class': Types.ProductInstance,
    ...productInstance
  }, 'POST', true);
}

export async function terminateProductInstance(uuid, userUuid = 'e6f3d782-7400-4015-a8db-aea734e60376') {
  return terminate(Types.ProductInstance, uuid, userUuid);
}

/** ProductInstanceDataController End **/

/** CoreDataController Start **/
export async function save(type, object, userUuid = 'e6f3d782-7400-4015-a8db-aea734e60376') {
  return execute(`/${userUuid}`, {
    '@class': type,
    ...object
  });
}

export async function terminate(type, uuid, userUuid) {
  return execute(`/${userUuid}`, {
    '@class': type,
    uuid
  }, 'DELETE', true);
}

export async function updatePassword(passwordUpdate) {
  return execute('/password-update', passwordUpdate, 'PUT', true);
}

export async function updatePasswordRaw(passwordUpdate) {
  return execute('/password-update/raw', passwordUpdate, 'PUT', true);
}

export async function fetchOne(type, uuid) {
  return new Promise(() => {});
}

export async function fetchOneWithTime(type, uuid, time) {
  return new Promise(() => {});
}

export async function fetchOneWithQuery(type, query) {
  return new Promise(() => {});
}

export async function fetchOneWithQueryAndTime(type, query, time) {
  return new Promise(() => {});
}

export async function invokeAll(...functions) {
  return Promise.all(
    functions.map(fn => fn())
  );
}

export async function fetchAllForEach(...types) {
  return invokeAll(...types.map(type => () => fetchAll(type)));
}

export async function fetchAll(type) {
  return execute('/all', {
    'clazz': type
  });
}

export async function fetchAllWithTime(type, time) {
  return new Promise(() => {});
}

export async function fetchAllWithQuery(query) {
  return execute('/queryAll', query);
}

export async function fetchAllWithQueryAndTime(query, time) {
  return execute(`/queryAll/${time}`, query);
}

export async function fetchChildren(type, parentUuid) {
  return new Promise(() => {});
}

export async function fetchChildrenWithTime(type, parentUuid, time) {
  return new Promise(() => {});
}

export async function getHistory(type, object) {
  return new Promise(() => {});
}

export async function fetchAllSiteControllers() {
  return fetchAllWithQuery(
    {
      clazz: Types.ProductInstance,
      criteria: {
        where: 'productId',
        methodCalls: [
          {
            name: 'is',
            argument: 'com.rewardsinc:site-controller-app'
          }
        ]
      }
    }
  )
}

export async function health() {
  const health = await execute('/health', null, 'GET', false, true);
  if (typeof health.status === 'string') {
    return null;
  }
  console.warn('Received this as a health response:', health);
  throw new Error('Invalid health response');
}
/** CoreDataController End **/



// WEBPACK FOOTER //
// ./src/services/core-data/index.js